import React, { lazy, Suspense } from 'react'
import { StorageProvider, LinkProvider } from './Context'
import { SnackbarProvider } from './Context/SnackbarContext'

const AuthProvider = lazy(() =>
  import(/* webpackChunkName: "auth-provider" */ './Context').then((module) => ({
    default: module.AuthProvider,
  }))
)

const FeatureProviders = lazy(
  () =>
    import(
      /* webpackChunkName: "feature-providers" */ './Routing/ContextLayouts/FeatureProviders'
    )
)

const MainRoutes = lazy(() =>
  import(/* webpackChunkName: "routing" */ './Routing').then((module) => ({
    default: module.MainRoutes,
  }))
)

const GlobalSignInModal = lazy(() =>
  import(/* webpackChunkName: "auth-components" */ './Components/Auth').then(
    (module) => ({
      default: module.GlobalSignInModal,
    })
  )
)

const AppProviders: React.FC = () => {
  return (
    <StorageProvider>
      <LinkProvider>
        <SnackbarProvider>
          <Suspense fallback={<></>}>
            <AuthProvider>
              <FeatureProviders>
                <MainRoutes />
                <GlobalSignInModal />
              </FeatureProviders>
            </AuthProvider>
          </Suspense>
        </SnackbarProvider>
      </LinkProvider>
    </StorageProvider>
  )
}

export default AppProviders
